import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TwoWheelerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"two_wheeler"}/>
}
